'use strict';

exports.__esModule = true;
exports.default = undefined;

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRangeslider = require('react-rangeslider');

var _reactRangeslider2 = _interopRequireDefault(_reactRangeslider);

var _Col = require('react-bootstrap/lib/Col');

var _Col2 = _interopRequireDefault(_Col);

var _Row = require('react-bootstrap/lib/Row');

var _Row2 = _interopRequireDefault(_Row);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MozartSlider = (_temp = _class = function (_Component) {
  (0, _inherits3.default)(MozartSlider, _Component);

  function MozartSlider(props) {
    (0, _classCallCheck3.default)(this, MozartSlider);

    var _this = (0, _possibleConstructorReturn3.default)(this, _Component.call(this, props));

    _this.setSliderValue = function () {
      _this.props.onChange(_this.state.value);
    };

    _this.handleChange = function (value) {
      _this.setState({
        value: value
      });
    };

    _this.styles = require('./MozartSlider.scss');
    _this.state = {
      value: _this.props.value
    };
    return _this;
  }

  MozartSlider.prototype.render = function render() {
    return _react2.default.createElement(
      'div',
      { className: this.styles.slider_container + ' mozart_slider' },
      this.props.labels && this.props.labels.length > 0 && _react2.default.createElement(
        'div',
        { className: this.styles.slider_label },
        _react2.default.createElement(
          _Row2.default,
          null,
          _react2.default.createElement(
            _Col2.default,
            { xs: 6, sm: 6, md: 6, lg: 6, className: this.styles.left_label },
            this.props.labels[0] ? this.props.labels[0] : ''
          ),
          _react2.default.createElement(
            _Col2.default,
            { xs: 6, sm: 6, md: 6, lg: 6, className: this.styles.right_label },
            this.props.labels[1] ? this.props.labels[1] : ''
          )
        )
      ),
      _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_reactRangeslider2.default, {
          min: this.props.min,
          max: this.props.max,
          value: this.state.value,
          onChange: this.handleChange,
          onChangeComplete: this.setSliderValue,
          tooltip: false,
          handleLabel: this.state.value
        })
      )
    );
  };

  return MozartSlider;
}(_react.Component), _class.propTypes = {
  onChange: _react.PropTypes.func,

  min: _react.PropTypes.number,
  max: _react.PropTypes.number,
  value: _react.PropTypes.number,
  labels: _react.PropTypes.array
}, _temp);
exports.default = MozartSlider;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/MozartSlider/MozartSlider.js
// module id = 2340
// module chunks = 0